/* eslint-disable*/
var arr = { "1": "frm", "2": "frm_2" };
var checkFrmFun = function checkFrmSubscription(selectedLevel, exam_data) {
  // console.log(selectedLevel);
  // console.log("selectedLevel");
  // console.log(exam_data);
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    // console.log('for working')
    if (
      exam_data[i].exam_name === arr[selectedLevel] ||
      exam_data[i].exam_name === "frm_1_2"
    ) {
      // console.log('if working')
      if (exam_data[i].levels.length) {
        // console.log("in if");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          // console.log(exam_data[i].levels);
          if (exam_data[i].levels[j].isActive) {
            //  console.log("in if")
            flag = true;
            // break;
          }
        }
      } else {
        // console.log("in else");
        flag = true; //for old user
      }
      // break;
    } else {
      // console.log("checkFrmSubscription ELSE");
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            (exam_data[i].levels[j].package_id === 16 ||
              exam_data[i].levels[j].package_id === 17 ||
              exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 20 ||
              exam_data[i].levels[j].package_id === 22 ||
              exam_data[i].levels[j].package_id === 23 ||
              exam_data[i].levels[j].package_id === 24 ||
              exam_data[i].levels[j].package_id === 25)
          ) {
            flag = true;
            // break;
          }
        }
      }
    }
  }
  return flag;
};

var checkFrmNotesSubscription = function checkFrmNotesSubscription(
  selectedLevel,
  exam_data
) {
  var flag = false;
  // console.log("notes");
  // console.log(selectedLevel);
  for (var i = 0; i < exam_data.length; i++) {
    // console.log("check notes");
    if (
      exam_data[i].exam_name === arr[selectedLevel] ||
      exam_data[i].exam_name === "frm_1_2"
    ) {
      //console.log("check subscription");
      if (exam_data[i].levels.length) {
        //console.log("check");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "expensive" &&
            exam_data[i].levels[j].isActive
          ) {
            flag = true;
            // break;
          } else if (
            exam_data[i].levels[j].package_val === "simple" &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].noteStatus !== false
          ) {
            flag = true;
            break;
          } else if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            exam_data[i].levels[j].isActive
          ) {
            // console.log("uppperwork");

            flag = true;
            // break;
          }
        }
      } else {
        flag = true; //for old user
      }
      // break;
    } else {
      // console.log("else");

      if (exam_data[i].levels.length) {
        // console.log("else length");

        for (var j = 0; j < exam_data[i].levels.length; j++) {
          // console.log("else for");

          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            (exam_data[i].levels[j].package_id === 16 ||
              exam_data[i].levels[j].package_id === 17 ||
              exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 20 ||
              exam_data[i].levels[j].package_id === 22 ||
              exam_data[i].levels[j].package_id === 23 ||
              exam_data[i].levels[j].package_id === 24 ||
              exam_data[i].levels[j].package_id === 25)
          ) {
            // console.log("lowewerrwork");

            flag = true;
            // break;
          }
        }
      }
    }
  }
  return flag;
};

var checkFrmVideosSubscription = function checkFrmVideosSubscription(
  selectedLevel,
  exam_data
) {

  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    if (
      exam_data[i].exam_name === arr[selectedLevel] ||
      exam_data[i].exam_name === "frm_1_2"
    ) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "expensive" &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].videoStatus !== false
          ) {
            flag = true;
            // break;
          } else if (
            exam_data[i].levels[j].package_val === "simple" &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].videoStatus !== false
          ) {
            flag = true;
            // break;
          } else if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].videoStatus !== false
          ) {
            flag = true;
            // break;/
          }
        }
      } else {
        flag = true;
      }
      // break;
    } else {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            exam_data[i].levels[j].videoStatus !== false &&
            (exam_data[i].levels[j].package_id === 16 ||
              exam_data[i].levels[j].package_id === 17 ||
              exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 20 ||
              exam_data[i].levels[j].package_id === 22 ||
              exam_data[i].levels[j].package_id === 23 ||
              exam_data[i].levels[j].package_id === 24 ||
              exam_data[i].levels[j].package_id === 25)
          ) {
            flag = true;
            // break;
          }
        }
      }
    }
  }
  return flag;
};

var checkFrmPDFSubscription = function checkFrmPDFSubscription(
  selectedLevel,
  exam_data,
  type
) {
  var flag = false;
  // mock entries always carry pdfstatus=false / noteStatus=false (DEFAULT_PACKAGE_DETAILS),
  // so gating expensive/unlimited on the matching flag filters them out.
  var requiredFlag = type === "notes" ? "noteStatus" : "pdfstatus";
  for (var i = 0; i < exam_data.length; i++) {
    if (
      exam_data[i].exam_name === arr[selectedLevel] ||
      exam_data[i].exam_name === "frm_1_2"
    ) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "expensive" &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j][requiredFlag] !== false
          ) {
            flag = true;
            // break;
          } else if (
            exam_data[i].levels[j].package_val === "simple" &&
            exam_data[i].levels[j].isActive
          ) {
            if (exam_data[i].levels[j].pdfstatus && type === "question") {
              flag = true;
            } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
              flag = true;
            }
            // break;/
          } else if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j][requiredFlag] !== false
          ) {
            flag = true;
            // break;
          }
        }
      } else {
        flag = true; //for old user
      }
      // break;
    } else {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            exam_data[i].levels[j][requiredFlag] !== false &&
            (exam_data[i].levels[j].package_id === 16 ||
              exam_data[i].levels[j].package_id === 17 ||
              exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 20 ||
              exam_data[i].levels[j].package_id === 22 ||
              exam_data[i].levels[j].package_id === 23 ||
              exam_data[i].levels[j].package_id === 24 ||
              exam_data[i].levels[j].package_id === 25)
          ) {
            flag = true;
            // break;
          }
        }
      }
    }
  }
  return flag;
};

var checkFormulaSheetSubscription = function checkFormulaSheetSubscription(
  selectedLevel,
  exam_data
) {
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    if (
      exam_data[i].exam_name === arr[selectedLevel] ||
      exam_data[i].exam_name === 'frm_1_2'
    ) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            (exam_data[i].levels[j].package_val === 'expensive' ||
              exam_data[i].levels[j].package_val === 'simple' ||
              exam_data[i].levels[j].package_val === 'unlimited') &&
            exam_data[i].levels[j].isActive
          ) {
            flag = true;
            // break;
          }
        }
      } else {
        flag = true; //for old user
      }
      // break;
    } else {
      // console.log("else");

      if (exam_data[i].levels.length) {
        // console.log("else length");

        for (var j = 0; j < exam_data[i].levels.length; j++) {
          // console.log("else for");

          if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            (exam_data[i].levels[j].package_id === 16 ||
              exam_data[i].levels[j].package_id === 17 ||
              exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 20 ||
              exam_data[i].levels[j].package_id === 22 ||
              exam_data[i].levels[j].package_id === 23 ||
              exam_data[i].levels[j].package_id === 24 ||
              exam_data[i].levels[j].package_id === 25)
          ) {
            // console.log("lowewerrwork");

            flag = true;
            // break;
          }
        }
      }
    }
  }
  return flag;
};
exports.checkFrm = checkFrmFun;
exports.checkFrmNotesSubscription = checkFrmNotesSubscription;
exports.checkFrmVideosSubscription = checkFrmVideosSubscription;
exports.checkFrmPDFSubscription = checkFrmPDFSubscription;
exports.checkFormulaSheetSubscription = checkFormulaSheetSubscription;



// WEBPACK FOOTER //
// ./src/views/RestAPI/FrmSubscription.js